import {
  DeploymentRequestsRestResource,
  GetEnvironmentCopyRequestsRequest,
  GetEnvironmentCopyRequestsResponse,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useGetEnvironmentCopyRequests = () =>
  useRestResourceHook<
    GetEnvironmentCopyRequestsRequest,
    GetEnvironmentCopyRequestsResponse
  >((request) =>
    DeploymentRequestsRestResource.getEnvironmentCopyRequests(request),
  );
